<template>
  <div>
    <v-container>
      <v-layout class="mb-4 pa-2">
        <v-flex>
          <h2 class="mt-0">{{ $t('Shop address') }}</h2>
        </v-flex>
      </v-layout>

      <shipping-address
        :isEdit="isEditShippingAddress"
        :init="contents"
        @onSave="isEditShippingAddress = false"
      ></shipping-address>
    </v-container>
    <v-container>
      <v-layout wrap class="mb-4 pa-2">
        <v-flex xs9>
          <h2 class="mt-0">{{ $t('Automatically sending tracking numbers') }}</h2>
          <span>{{
            $t(
              'Remark: Enable automatically sending tracking numbers via LINE will be a fee for sending messages according to the package specified by LINE.'
            )
          }}</span>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <toggle-button
            class="mt-2"
            :value="toggleLineAutoSendOrderTrackingStatus"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="onChangeToggleLineAutoSendOrderTrackingStatus"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider />
    <v-container>
      <div v-if="loading" class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
      <div v-else>
        <v-layout class="pa-2">
          <v-flex xs10>
            <div class="col s12 d-flex justify-space-between">
              <label>{{ $t('Display product weight on shop service') }}</label>
            </div>
            <div class="col s12 form-control">
              <div class="primary-color">{{ setWeight() }}</div>
            </div>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <v-btn
              @click="isEdit = true"
              v-if="isEdit != true"
              fab
              outline
              small
              color="primary"
              
            >
              <v-icon>edit</v-icon>
            </v-btn>
            <div class=" text-xs-right">
              <toggle-button
                v-if="isEdit"
                :value="toggleSetWeight"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="onChangeStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
            </div>
            <div class="row text-xs-center mb-2"></div>
          </v-flex>
        </v-layout>
        <div class="row text-xs-center mb-2">
          <div class="col s12">
            <template v-if="isEdit">
              <v-btn @click="cancelEdit" outline color="grey">{{ $t('cancel') }}</v-btn>
              <v-btn
                @click="saveContent"
                :loading="loading"
                :disabled="loading"
                depressed
                color="primary"
                >{{ $t('Save') }}</v-btn
              >
            </template>
          </div>
        </div>
      </div>
    </v-container>
    <v-divider />
    <v-container>
      <v-layout wrap class="mb-4">
        <v-flex xs9>
          <h2 class=" mt-0">{{ $t('Shipping Method') }}</h2>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <span
            style="border-bottom:1px solid grey; cursor: pointer;"
            v-if="!isShowall"
            @click="isShowall = true"
          >
            {{ $t('show_all') }}
          </span>
          <span
            style="border-bottom:1px solid grey; cursor: pointer;"
            v-if="isShowall"
            @click="isShowall = false"
          >
            {{ $t('un_show_all') }}
          </span>
        </v-flex>
      </v-layout>
      <shipping-detail :isShow="isShowall" :init="contents"></shipping-detail>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import SortProduct from './SortProduct.vue'
import ShippingDetail from '@/components/view/setting/ecommerce/ShippingDetail'
import ShippingAddress from '@/components/view/setting/ecommerce/ShippingAddress'
import ShippopManage from './ShippopManage'
import AkitaManage from './AkitaManage'
import PackhaiManage from './PackhaiManage'
import SokochanManage from './SokochanManage'
import ZortOutManage from './ZortOutManage'
import ScgManage from './ScgManage'
import JandtManage from './JandtManage'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  data() {
    return {
      isEditShippingAddress: false,
      isEditPaymentDetail: false,
      isShowall: false,
      isTransfer: false,
      isCreditCard: false,
      contents: [],
      toggleSetWeight: false,
      toggleLineAutoSendOrderTrackingStatus: false,
      isEdit: false,
      loading: false
    }
  },
  components: {
    ShippingDetail,
    ShippopManage,
    AkitaManage,
    ShippingAddress,
    PackhaiManage,
    ToggleButton,
    SokochanManage,
    ZortOutManage,
    ScgManage,
    JandtManage
  },
  mounted() {
    this.toggleSetWeight = this.selectedBot.is_display_transport_weight
    this.toggleLineAutoSendOrderTrackingStatus = this.selectedBot.line_auto_send_order_tracking_status
    this.getSetting()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async onChangeToggleLineAutoSendOrderTrackingStatus() {
      this.toggleLineAutoSendOrderTrackingStatus = !this.toggleLineAutoSendOrderTrackingStatus
      this.$store.dispatch('loading')
      var data = {
        body: { line_auto_send_order_tracking_status: this.toggleLineAutoSendOrderTrackingStatus },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
        this.$store.dispatch('updateBotDetail')
      } else {
        this.toggleLineAutoSendOrderTrackingStatus = !this.toggleLineAutoSendOrderTrackingStatus
      }
      this.$store.dispatch('loading')
    },
    cancelEdit: function() {
     this.isEdit=false
    },
    saveContent: function() {
      let vm = this
      this.putPageReceiptConfig(this.toggleSetWeight)
    },
    gotoshippop() {
      this.$el.querySelector('[id="shippop"]').scrollIntoView()
    },
    onChangeStatus() {
      this.toggleSetWeight = !this.toggleSetWeight
    },
    async putPageReceiptConfig() {
     this.loading = true
      var data = {
        body: { is_display_transport_weight: this.toggleSetWeight },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
        this.$store.dispatch('updateBotDetail')
      } else {
        this.toggleSetWeight = !this.toggleSetWeight
      }
      this.loading = false
      this.isEdit = false
    },
    setWeight() {
      const vm = this
      if (vm.toggleSetWeight != false) {
        return vm.$t('on_set_weight')
      } else {
        return vm.$t('off_set_weight')
      }
    },
    getSetting: function() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid
      }

      api.getSetting(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.contents = {}
        if (response.data) {
          response.data.map(function(setting, index) {
            vm.contents[setting.contenttype] = setting
            if (setting.contenttype === 'allowtransfer') {
              vm.isTransfer = setting.contentvalue
            }
            if (setting.contenttype === 'allowcreditcard') {
              vm.isCreditCard = setting.contentvalue
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippingMain.vue